import React from 'react'

const SearchIcon20pxSvg = (props) => {
    return (
        <svg 
        {...props}
        xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M14.167 9.167a5 5 0 1 1 -10.002 0A5 5 0 0 1 14.167 9.167m-0.912 5.267a6.667 6.667 0 1 1 1.178 -1.178l2.882 2.882a0.833 0.833 0 0 1 -1.178 1.178z" fill="white"/></svg>
    )
}

export default SearchIcon20pxSvg